import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white">
            <h5 className="text-white">
              <br />
              <br />
            </h5>
          </Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Your career highlights your success in driving digital transformation
                initiatives.What are the key pillars of your digital transformation strategy, and
                how do you prioritize modernization efforts within the bank?
              </strong>
            </h5>

            <h5 className="text-white">
              The key pillars are mainly around six areas:
              <ol>
                <li>Customer-centricity</li>
                <li>Data analytics and AI</li>
                <li>Modernizing the Technology Stack</li>
                <li>Cybersecurity and compliance</li>
                <li>People</li>
                <li>Process</li>
              </ol>
              <br />
              We have a vision for the bank of the future, and we ensure that our short- and
              long-term plans and actions help us reach our goal.
              <br />
              <br />
              We prioritize modernization efforts based on their impact on business and customers,
              regulatory requirements, and operational efficiency. Our technology strategy is
              closely aligned with business objectives and the future of the industry.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Innovation is a cornerstone of your leadership approach.How is your bank
                leveraging advanced technologies such as AI, cloud computing, and big data to
                enhance operational efficiency?
              </strong>
            </h5>
            <h5 className="text-white">
              We are using machine learning for cross-selling and up-selling opportunities, risk
              management, and we are introducing generative AI services for our employees first.
              While cloud adoption is prohibited locally by the regulator, we are building our
              private cloud, which can be easily integrated with or migrated to the public cloud
              later. Using a private cloud makes us highly responsive to increasing business demands
              and growth while ensuring scalability, cost efficiency, and resilience. Finally, we
              are heavily investing in modern data platforms and infrastructure, developing
              real-time dashboards, machine learning models, and automating data flows between
              different systems for various use cases. These efforts help the business grow,
              identify opportunities, improve customer services and relationships, and manage risks
              effectively.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With increasing digital adoption, cybersecurity is more critical than ever.How do
                you balance the need for innovation with maintaining robust cybersecurity
                frameworks?
              </strong>
            </h5>
            <h5 className="text-white">
              Innovation and cybersecurity must coexist. We have embedded cybersecurity into every
              layer of innovation and digital transformation. Each new initiative undergoes
              technology risk assessments and security testing from the early design phase to
              post-implementation review, followed by periodic security scans and tests.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Customer experience remains at the heart of digital transformation.How are digital
                solutions transforming customer interactions and satisfaction within your bank?
              </strong>
            </h5>
            <h5 className="text-white">
              Our customers are at the core of all our services and solutions, and we are redefining
              customer interactions through:
              <ol>
                <li>Seamless online and mobile banking experiences</li>
                <li>AI-driven personalized offers and services</li>
                <li>Faster and more reliable transactions</li>
                <li>Self-service capabilities across various channels</li>
                <li>Customer feedback loops</li>
              </ol>
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Partnerships can accelerate innovation and expand service capabilities.How
                important are collaborations with fintech companies and technology providers in your
                digital transformation journey?
              </strong>
            </h5>
            <h5 className="text-white">
              Competition in banking and financial services is intense, and the only way for banks
              to survive is by adopting open banking and open finance services. Customers can easily
              shift from one bank to another for better, more seamless services. Collaboration and
              partnerships with fintech companies and technology providers are crucial in our
              digital journey. They expand service offerings, enhance financial inclusion, and
              reduce cost and complexity.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-The banking industry is undergoing rapid transformation. What is your vision for
                the future of banking in North Africa, and how will technology shape this
                transformation?
              </strong>
            </h5>
            <h5 className="text-white">
              The future of banking in North Africa is shaped by its high mobile penetration, large
              unbanked population, and strong remittance flows. Unlike other regions, fintech and
              mobile banking are the keys to financial inclusion. Regulatory evolution is slower
              than in Europe but is catching up with open banking. The informal economy plays a
              major role, making embedded finance, partnerships with telecom companies, fintech, and
              micro-lending critical. Remittances drive demand for cheaper, faster digital payments.
              Cybersecurity and compliance must evolve to counter growing digital threats. Banks
              that embrace innovation, localized solutions, and regulatory alignment will lead North
              Africa’s financial transformation.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Building strong IT teams is essential for successful digital initiatives.What
                strategies do you employ to attract, develop, and retain top IT talent?
              </strong>
            </h5>
            <h5 className="text-white">
              Building a strong IT team requires a clear vision, a competitive and winning mindset,
              and a continuous learning environment. To attract top talent, I focus on offering
              challenging projects, leveraging emerging technologies (AI & automation), and
              fostering a culture of innovation. To develop talent, I invest in training,
              mentorship, and cross-functional exposure. To retain IT professionals, I ensure career
              growth opportunities, competitive compensation, a healthy culture, strong teamwork,
              and a purpose-driven mission. Additionally, I promote agility, empowerment, and
              collaboration to keep the team engaged and motivated. A culture of continuous learning
              and innovation is key to maintaining a high-performing IT team.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Closing Remark- You will be speaking at Finnovex North Africa on April 23rd. What
                key message or insight would you like to convey to the audience regarding the role
                of technology in shaping the future of banking in the region?
              </strong>
            </h5>
            <h5 className="text-white">
              The future of banking is defined by how quickly and efficiently we can use technology
              to introduce and improve banking services and products. The technology team should not
              be viewed as merely an enabler but as the core of banking evolution. To succeed, banks
              must invest heavily in people and their digital and technical skillsets. AI and
              automation must be embedded in all services and processes, and banks must be
              data-driven to prioritize customer experience. Collaboration with fintech companies,
              telecom providers, and technology firms is essential. The future will not favor banks
              that are not digitally first, easily integrated, open, seamless, secure, reliable, and
              personalized.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
